import { h, render, Component } from 'preact';
import { Wizard } from '../wizard';

export class InfoAppInstall extends Component {

  constructor(props) {
    super(props);

    this.state = {
      smsSent: false
    }

  }

  smsInstall = e => {
    var me = this;

    fetch(
      "/api/v1/enroll/sms-install"
    ).then( resp => {
      return resp.json();
    }).then( data => {
      // console.log('api/v1/enroll/sms_install', data);
      me.setState({smsSent: true});
    });
  }

  render(props, state) {
		return (
      <Wizard isPanel="true"
        title={"Install Duo Mobile for "+(props.deviceOS=="ios"?'iOS':'Android')}
        next={{callback: props.next, label: "I have Duo Mobile Installed"}}
        prev={{callback: props.prev}}>
        { props.deviceType == 'mobile' &&
          <div style="text-align:center;">
            { state.smsSent == false ?
            <div class="touchBtn secondary" style="display:block;" onClick={this.smsInstall}><i class="fa fa-commenting"></i>&nbsp;Text an install link to {props.formattedPhoneNumber}</div>:
            <div class="touchBtn" style="display:block;"><i class="fa fa-check" style="color:#00A19B;"></i>&nbsp;An install link was sent to {props.formattedPhoneNumber}</div>
            }
            <h3>OR</h3>
          </div>
        }
        <ol>
          <li>Launch the {props.deviceOS=='ios'?'App Store':'Google Play Store app'} and search for "Duo Mobile"</li>
          <li>Tap {props.deviceOS=='ios'?'"GET" and then confirm the install':'"Install" to install the app'}</li>
        </ol>
      </Wizard>
		)
  }
}
